export class Costants {
  static optionSort = ["relevance","date_of_text"];

  static typeJson = [
    { id: "P", name: "policies" },
    { id: "L", name: "laws" },
    { id: "R", name: "regulations" },
    { id: "M", name: "miscellaneous" },
    { id: "C", name: "constitutions" },
    { id: "A", name: "agreements" }
  ];

  static psJson = [
    { id: "AG", name: "agricolture" },
    { id: "PL", name: "cultivated_plants" },
    { id: "EN", name: "enviroment" },
    { id: "FI", name: "fisheries" },
    { id: "FD", name: "food_nutrition" },
    { id: "FO", name: "forestry" },
    { id: "LA", name: "land_soil" },
    { id: "AN", name: "livestock" },
    { id: "MR", name: "mineral_resources" },
    { id: "SE", name: "sea" },
    { id: "WA", name: "water" },
    { id: "WB", name: "spicies_eco" }
    
  ];

  static mapQuery = [
    "record",
    "title",
    "topic",
    "subjectselection",
    "country",
    "geographicalareas",
    "NOT repealed",
    "typeoftext",
    "organizationid",
    "implementstre",
    "keyword"
  ];

  static facetsMap = [
    {field: "countries", name: "By Country/Territory", priority: 7},
    {field: "mainareas", name: "By Primary Subject", priority: 3},
    {field: "subjectselections", name: "By Domain", priority: 2},
    {field: "keywords", name: "By Keywords", priority: 4},
    {field: "geographicalareas", name: "By Geographical Area", priority: 5},
    {field: "typeoftexts", name: "By Type Of Text", priority: 9},
    {field: "documentlanguages", name: "By Languages", priority: 11},
    {field: "territorialsubdivisions", name: "By Territorial Subdivision", priority: 8},
    {field: "organization", name: "By Regional Organization", priority: 6},
    {field: "facetyear", name: "By Year", priority: 10},
    {field: "topic", name: "By Topic", priority: 1},
    {field: "typeoftext", name: "By Type", priority: 12}
  ];

  static yearFromMap = ["yearfrom", "originalyearfrom"];
  static yearToMap = ["yearto", "originalyearto"];

  static tableInfoMap = [
    {field: "serialImprint", name: "Serial Imprint"},
    {field: "typeOfText", name: "Type of text"},
    {field: "relatedWebSite", name: "Related web site"},
    {field: "faolexid", name: "Lex."},
    {field: "documentLanguageEn", name: "Document language"},
    {field: "dateOfText", name: "Date of text"},
    {field: "dateOfOriginalText", name: "Date of original text"},
    {field: "dateOfConsolidation", name: "Last amended date"},
    {field: "keyword", name: "Keywords"},
    {field: "subjectSelectionEn", name: "Domains"},
    {field: "mainAreaEn", name: "Primary Subjects"},
    {field: "dateOfModification", name: "Date of modification"}
  ];

  static tableAllviewMap = [
    "topic",
    "type",
    "titleOfText",
    "dateOfText",
    "faolexId",
    "typeOfText"
  ];

  // Key: SectionTitle_en; Value: translation key for the descriptive textbox
  static allowedSectionEnDescriptiveTextbox = {
    "CITES-related legislation (Wild species)": "wild_species",
    "CITES-related legislation (Fisheries)": "fisheries",
    "CITES-related legislation (Forestry)": "forestry",
    "Additional legislation (Environment)": "enviroment",
    "Additional legislation (Customs/international trade)": "customs_internal_trade",
    "Additional legislation (Indigenous peoples and local communities)": "indigenous_peoples",
    "Additional legislation (Public health)": "public_health",
    "Additional legislation (Animal health)": "animal_health",
    "Additional legislation (Animal production)": "animal_production",
    "Additional legislation (Animal welfare)": "animal_welfare",
    "Additional legislation (Plant health)": "plant_health"
  };
}
